var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voerro-notifications-container",class:this.class},[_vm._l((_vm.items),function(item){return _c('notification',{key:item.id,attrs:{"data-notification":item,"data-theme":_vm.theme,"hide-after":_vm.delay},on:{"destroy":function($event){_vm.pull(item.id)}}})}),_vm._v(" "),(_vm.sound)?_c('audio',{attrs:{"id":"voerro-notifications-player","src":_vm.sound}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ff0126","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 19
// module chunks = 0